// extracted by mini-css-extract-plugin
module.exports = {"uploadButtons":"style_uploadButtons__suUjt","categoryDropdown":"style_categoryDropdown__2kPO2"};